export class FlowApproveRequest {

    constructor(
      public ApproveAll: boolean = false,
      public FlowOIDs: Array<number> = []
    ) {
    }
  
  }
  